import { useEffect, useState, useCallback } from 'react';

function readHashRoute() {
  if (typeof window === 'undefined') return '';
  const h = window.location.hash.replace(/^#\/?/, '');
  return h;
}

export function useRoute() {
  const [route, setRoute] = useState(readHashRoute);

  useEffect(() => {
    const onChange = () => setRoute(readHashRoute());
    window.addEventListener('hashchange', onChange);
    return () => window.removeEventListener('hashchange', onChange);
  }, []);

  const navigate = useCallback((to) => {
    const target = to.startsWith('#') ? to : `#${to}`;
    if (window.location.hash !== target) {
      window.location.hash = target;
    } else {
      setRoute(readHashRoute());
    }
  }, []);

  return { route, navigate };
}
